<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsEmailMergeService.showDetailedView"
         [ngStyle]="{width: settingsEmailMergeService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Corporation'"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsEmailMerge'" [ngClass]="{'sk-loading': settingsEmailMergeService.spinnerShow}">
                    <corporations-list></corporations-list>
                    <spinner [spinnerShow]="settingsEmailMergeService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsEmailMergeService.data.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsEmailMergeService.data.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <settings-email-merge-detailed-view></settings-email-merge-detailed-view>
    </div>
</div>
<notifications-modal *ngIf="settingsEmailMergeService.showNotificationsModal"></notifications-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/settings-email-merge.component.html